import axios from 'axios';
import { API_BASE_URL } from '@config';

export const SET_KEY = 'SET_KEY';
export const setKey = token => ({
	type: SET_KEY,
	payload: token
});

export const KEY_REQUEST = 'KEY_REQUEST';
export const keyRequest = () => ({
	type: KEY_REQUEST
});

export const SET_LICENSE_ERROR = 'SET_LICENSE_ERROR';
export const setError = err => ({
	type: SET_LICENSE_ERROR,
	payload: err
});

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const clearError = () => ({
	type: CLEAR_ERROR
});

// More robust solution to handle API_BASE_URL loading
export const checkKey = () => dispatch => {
	dispatch(keyRequest());
	
	// Function to get a valid API URL
	const getApiUrl = () => {
		// If we have API_BASE_URL configured, use it
		if (API_BASE_URL) {
			return API_BASE_URL;
		}
		
		const fallbackUrl = window.location.origin;
		return fallbackUrl;
	};
	
	// Function to attempt the API call
	const attemptApiCall = (retryCount = 0, maxRetries = 5) => {
		const apiUrl = getApiUrl();
		
		return axios
			.get(`${apiUrl}/api/license`)
			.then(res => {
				if (res.data && res.data.licenseType) {
					dispatch(setKey(res.data.licenseType));
				} else {
					console.warn('License API response missing licenseType:', res.data);
					dispatch(setKey('unknown'));
				}
			})
			.catch(err => {
				const status = err.response ? err.response.status : 'unknown';
				const errorMsg = err.response && err.response.data ? err.response.data.message : err.message;
				console.error(`License API error (${status}):`, errorMsg);
				
				// Retry logic with exponential backoff
				if (retryCount < maxRetries) {
					const delay = Math.min(1000 * Math.pow(1.5, retryCount), 10000); // Start at 1s, max 10s
					console.log(`API call failed, retrying in ${delay/1000}s (attempt ${retryCount + 1}/${maxRetries})...`);
					return setTimeout(() => attemptApiCall(retryCount + 1, maxRetries), delay);
				} else {
					console.error('Max retries reached, giving up.');
					return dispatch(setError(err));
				}
			});
	};
	
	// Start trying to call the API
	return attemptApiCall();
};
